export default __webpack_public_path__ + "static/media/soundFour.9ea56cbd.wav";